<template>
  <div class="flex">
    <input
      :id="name"
      v-model="internalModel"
      type="checkbox"
      :value="value"
      class="border-1 rounded-md border-brd hover:cursor-pointer"
      :class="{
        'active:bg-thm-contrast checked:bg-thm-light hover:checked:bg-thm-light hover:active:bg-thm-light':
          disabled,
        'focus:ring-2 hover:bg-thm-light hover:border-thm-reduced': !disabled,
        'border-cta-active': error,
        'w-5 h-5 mt-0.5 mr-2': size === 'md',
        'w-4 h-4 mt-0 mr-0.5': size === 'sm',
      }"
    />

    <label class="flex hover:cursor-pointer" :for="name">
      <div class="flex flex-col">
        <span
          class="font-normal"
          :class="[
            disabled ? 'text-txt-weak' : 'text-txt-strongest hover:text-txt',
            size === 'sm' ? 'text-sm' : 'text-base',
          ]"
        >
          <slot></slot>
        </span>

        <p
          v-if="hint"
          class="font-normal text-txt-weak"
          :class="size === 'sm' ? 'text-xs' : 'text-sm'"
        >
          {{ hint }}
        </p>
      </div>

      <WebccIcon
        v-if="error"
        class="mt-0.5 ml-2 text-cta-active"
        :class="size === 'sm' ? 'h-4 w-4' : 'h-5 w-5'"
        name="site/error-warning"
      />
    </label>
  </div>
</template>

<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    value: RedesignWebccCheckboxOptionValue
    disabled?: boolean
    hint?: string
    error?: boolean
    type?: 'single' | 'group'
    size?: Size
    id?: string
  }>(),
  {
    type: 'single',
    hint: '',
    size: 'md',
  },
)

const model = defineModel<boolean | string | string[]>({
  required: true,
})

const internalModel = computed({
  get: () => {
    if (props.type === 'group') {
      if (Array.isArray(model.value)) {
        return model.value
      } else if (typeof model.value === 'string') {
        return model.value.split(',')
      }

      return []
    }

    return model.value ?? false
  },

  set: (value) => {
    model.value = value
  },
})

const id = props.id || useId()
const name = computed(() => `checkbox-${id}-${props.value}`)
</script>
